/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { OralExamStudentSupervisorFaceResponse } from './oralExamStudentSupervisorFaceResponse';

export type OralExamStudentSupervisorViewResponseVisitor = OralExamStudentSupervisorFaceResponse | null;
